import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import s from "./AccountStatusDialog.module.scss";
import AgentStatusOptions from "utils/AgentStatusOptions/AgentStatusOptions";
import Selection from "components/Input/Selection/Selection";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";
import { isNullish } from "utils/utils";

const DIALOG_LOCALE_KEY = "page.dialogs.";
const remarkOthersKey = "OTHERS";

const AccountStatusDialog = ({ data, remarksList, updatePayload }) => {
  const { t } = useTranslation();
  const [focus, setFocus] = useState({});

  remarksList["TERMINATED"][remarkOthersKey] = t(
    DIALOG_LOCALE_KEY + "changeStatus.remarkOthers.value",
  );
  remarksList["SUSPENDED"][remarkOthersKey] = t(
    DIALOG_LOCALE_KEY + "changeStatus.remarkOthers.value",
  );

  const INPUT_FIELD_INIT_STATE = {
    status: data.status,
    reason: data.lockAccountType ? data.lockAccountType : "",
    remark: data.remark ? data.remark : "",
  };

  const [fieldInput, setFieldInput] = useState(INPUT_FIELD_INIT_STATE);

  const [reasonList, setReasonList] = useState(remarksList[data.status]);

  const statusOnChange = (e, callback) => {
    let { value } = e.target;
    if (callback) {
      value = callback(value);
    }
    updateReasonList(value);
  };

  const textInputOnChange = (e, field, callback) => {
    let { value } = e.target;
    if (callback) {
      value = callback(value);
    }
    setFieldInput({ ...fieldInput, [field]: value });
    updatePayload({ ...fieldInput, [field]: value });
  };

  const textInputOnFocus = (field) => {
    setFocus({ [field]: true });
  };

  const textInputOnBlur = (field, callback) => {
    if (fieldInput[field] && callback) {
      const isValidValue = callback(fieldInput[field]);
      if (!isValidValue) {
        setError({ ...error, [field]: error });
      }
    }
    setFocus({ [field]: false });
  };
  const isInputRemarksDisabled = () => {
    return !(fieldInput.reason == remarkOthersKey);
  };
  const updateReasonList = (newstatus) => {
    setReasonList(remarksList[newstatus]);
    setFieldInput({ ...fieldInput, status: newstatus, reason: "", remark: "" });
    updatePayload({ ...fieldInput, status: newstatus, reason: "", remark: "" });
  };

  const getReasonListEmpty = () => {
    if (isNullish(reasonList)) return true;
    return reasonList.length == 0;
  };

  const getReasonList = () => {
    if (!isNullish(reasonList)) {
      const keys = Object.keys(reasonList);
      return keys.map((reason) => {
        return {
          key: reason,
          title: reasonList[reason],
          value: reason,
        };
      });
    }
    return [];
  };

  return (
    <div className={s.contentContainer}>
      <Selection
        label={t(DIALOG_LOCALE_KEY + "changeStatus.selectStatus.label")}
        selectionValue={fieldInput.status}
        onchangeFn={(e) => statusOnChange(e)}
        onfocusFn={() => textInputOnFocus("status")}
        onblurFn={() => textInputOnBlur("status")}
        options={AgentStatusOptions("all")}
        sxParams={{ selectionFocus: focus.status }}
      />
      <div className={getReasonListEmpty() ? s.inactive : ""}>
        <Selection
          label={t(DIALOG_LOCALE_KEY + "changeStatus.selectReason.label")}
          selectionValue={fieldInput.reason}
          onchangeFn={(e) => textInputOnChange(e, "reason")}
          onfocusFn={() => textInputOnFocus("reason")}
          onblurFn={() => textInputOnBlur("reason")}
          options={getReasonList()}
          sxParams={{ selectionFocus: focus.reason }}
          disabled={getReasonListEmpty()}
        />
      </div>
      <div className={isInputRemarksDisabled() ? s.inactive : ""}>
        <OutlinedText
          label={t(DIALOG_LOCALE_KEY + "changeStatus.inputRemark.label")}
          value={fieldInput.remark}
          onchangeFn={(e) => textInputOnChange(e, "remark")}
          onfocusFn={() => textInputOnFocus("remark")}
          onblurFn={() => textInputOnBlur("remark")}
          sxParams={{ textFocus: focus.remark }}
          disabled={isInputRemarksDisabled()}
        />
      </div>
    </div>
  );
};

export default AccountStatusDialog;
